module.exports = __webpack_public_path__ + "static/media/real_time_sign_language_detector_logo.6574b24c.png";